import cache from './cache'

class Branding {

  default_logo = "/img/temp-stick/logo-temp-stick-medium-blue-white.png"

  brands = {
    AF: "/img/logos/anti-freeze-tech.svg"
  }

  constructor () {
    this.currentBrand = "default";
  }

  updateLogo() {

    this.$logo = $(".app-menu-logo")

    let brand_key = cache.get("branding");

    if(brand_key && brand_key.value) {

      brand_key = brand_key.value;
      this.currentBrand = brand_key;

    } else {
      brand_key = this.currentBrand;
    }

    if(this.brands[brand_key]) {
      this.$logo.html(`<img src="${this.brands[brand_key]}" class="logo--large" alt="logo" />`)
    } else {
      this.$logo.html(`<img src="${this.default_logo}" class="logo--temp-stick" alt="logo" />`)
    }

  }

  maybeUpdateBranding(sensor_id) {

    this.$logo = $(".app-menu-logo")

    let brand_key = sensor_id.substr(2, 2)

    if(this.brands[brand_key]) {

      this.currentBrand = brand_key;
      this.$logo.html(`<img src="${this.brands[brand_key]}" class="logo--large" alt="logo" />`)

    } else {
      this.currentBrand = "default";
      this.$logo.html(`<img src="${this.default_logo}" class="logo--temp-stick" alt="logo" />`)
    }

    cache.save("branding", brand_key)

    console.log({brand_key})

  }

}

const BrandingInstance = new Branding();

export default BrandingInstance;

